import { CCStyling, DefaultStyling } from "../CCStyling";
import { createElement } from "../CCUtility";
import {
  CCInteractiveTableColumn,
  CCInteractiveTableOptions
} from "../types/table";
import { CCWrapper } from "./Form";
import { CCIcon } from "./UI";

export function CCTableRemoveRowButton() {
  return createElement(
    "th",
    "removeRowHead",
    DefaultStyling.removeRowButton,
    CCIcon("remove", "invisible")
  );
}
export function CCTableAddRowButton(
  columns: CCInteractiveTableColumn[],
  options: CCInteractiveTableOptions
) {
  return (
    `<tfoot><tr><td class="${options.addRowClass} noPrint" ` +
    `colspan="${columns.length + (options.removeRowButton ? 1 : 0)}" ` +
    `style="${DefaultStyling.tfoot.compile()}">` +
    CCIcon("plus", "", "", CCStyling.fromObject({ padding: "5px" })) +
    `</td></tr></tfoot>`
  );
}

export function CCTable(
  columns: CCInteractiveTableColumn[],
  options: CCInteractiveTableOptions
): string {
  let header = "";
  if (options.removeRowButton === "left") {
    header += CCTableRemoveRowButton();
  }
  columns.forEach((column) => {
    const style = CCStyling.fromObject({
      padding: "5px",
      width: column.width
    });
    header += createElement("th", "", style, column.display);
  });
  if (options.removeRowButton === "right") {
    header += CCTableRemoveRowButton();
  }
  header = `<tr>${header}</tr>`;

  const footer = options.addRowButton
    ? CCTableAddRowButton(columns, options)
    : "";

  return CCWrapper(
    createElement(
      "table",
      "",
      DefaultStyling.table,
      createElement("thead", "", DefaultStyling.thead, header) +
        `<tbody id="${options.bodyID}"></tbody>${footer}`
    ),
    "",
    CCStyling.fromObject({
      width: `min(${options.widthOverride ?? "1020px"}, 100%)`
    })
  );
}
